import moment from "moment";
require("moment/locale/cs");
//let numeral = require('numeral');
import { Libs } from "./libs";
export default {
  simnao(value) {
    let ret = "";
    switch (value) {
      case "0":
        ret = "Não";
        break;
      case "1":
        ret = "Sim";
        break;
      case "-1":
        ret = "---";
        break;
    }
    return ret;
  },
  deferimento(value) {
    let ret = "";
    switch (value) {
      case "0":
        ret = "Em analise";
        break;
      case "1":
        ret = "Deferido";
        break;
      case "2":
        ret = "indeferido";
        break;
    }
    return ret;
  },
  reduzPalavra(value, dig = 2) {
    return value.substring(0, dig);
  },
  numbr(value, digit = 4) {
    let n = parseFloat(value);
    if (isNaN(n)) {
      value = 0;
    }
    let myObj = {
      style: "decimal",
      maximumFractionDigits: digit,
      minimumFractionDigits: digit,
    };
    let nr = new Number(value).toLocaleString("pt-BR", myObj);
    return nr;
  },
  filterStatus(value) {
    let ret = "";
    switch (value) {
      case "0":
        ret = "Bloqueado";
        break;
      case "1":
        ret = "Livre acesso";
        break;
    }
    return ret;
  },
  filterNotificacaoCardapio(value) {
    let ret = "";
    switch (value) {
      case "0":
        ret = "Semanal";
        break;
      case "1":
        ret = "Mensal";
        break;
    }
    return ret;
  },
  filterCpf(value) {
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  },
  filterTimestaoTodate(value) {
    if (parseInt(value) > 0) {
      return moment.unix(value).format("MM/DD/YYYY HH:mm:ss");
    } else {
      return "";
    }
  },
  diassemansa(value) {
    let ar = [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sabado",
    ];
    if (value < 0) {
      return "---";
    } else {
      return ar[value];
    }
  },
  diasSemanaReduz(value) {
    let ar = ["Dm", "Se", "Te", "Qa", "Qi", "Sx", "Sb"];
    if (value < 0) {
      return "---";
    } else {
      return ar[value];
    }
  },
  vinculopedido(value) {
    let x = "";
    if (parseInt(value) == 1) {
      x = "Cronograma";
    } else {
      x = "Manual";
    }

    return x;
  },
  dateBr(value) {
    // let y = value.split(' ')
    let y = String(value).trim();
    let dd = y.split(" ");
    let x = "";
    if (y.length >= 10) {
      x = new Date(value).toLocaleDateString("pt-BR", { timeZone: "UTC" });
      if (dd.length == 2) {
        x = `${x} ${dd[1]}`;
      }
    }
    return x;
    /* if (a == 1) {
       
         }
         let ret = ''
         if ((typeof value) == 'undefined') {
             ret = ''
         }
         if ((typeof value) == 'string') {
             if (value.length == 0) {
                 ret = ''
             } else {
                 if (y.length == 1) {
                     ret = moment(x).format('DD/MM/YYYY')
                 } else {
                     ret = moment(x).format('DD/MM/YYYY HH:mm:ss')
                 }
 
 
             }
    }


        return ret*/
  },
  diaSem(value) {
    value = parseInt(value) + 1;
    let d = ["---", "Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
    return d[parseInt(value)];
  },
  meses(value) {
    let M = [
      "JANEIRO",
      "FEVEREIRO",
      "MARÇO",
      "ABRIL",
      "MAIO",
      "JUNHO",
      "JULHO",
      "AGOSTO",
      "SETEMBRO",
      "OUTUBRO",
      "NOVEMBRO",
      "DEZEMBRO",
    ];
    return M[value];
  },
  mesesI(value) {
    let M = [
      "",
      "JANEIRO",
      "FEVEREIRO",
      "MARÇO",
      "ABRIL",
      "MAIO",
      "JUNHO",
      "JULHO",
      "AGOSTO",
      "SETEMBRO",
      "OUTUBRO",
      "NOVEMBRO",
      "DEZEMBRO",
    ];
    return M[value];
  },
  mesesRedz(value) {
    let M = [
      "",
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ",
    ];
    return M[value];
  },
  modulocalculoedital(value) {
    let m = ["Menor Preço", "Preço Médio", "Maior Preço"];
    return m[value];
  },
  toUppers(value) {
    if (value != null) {
      return value.toUpperCase();
    } else {
      return "";
    }
  },
  toCapitalizeFirst(value) {
    if (value != null) {
      return Libs.capitalize(value, ". ");
    } else {
      return "";
    }
  },
  toCapitalize(value) {
    if (value != null) {
      return Libs.capitalize(value, " ");
    } else {
      return "";
    }
  },
  cicloLogistico(value) {
    let ciclo = [
      "Administrativo",
      "Instituição alteração",
      "Fornecedor Entrega / Instituição Aceite",
      "Instituição Aceite",
      "Encerrado",
    ];
    return ciclo[value];
  },
};
